import {
    DEALERADDORUPDATEDSRLIST_FAILED,
    DEALERADDORUPDATEDSRLIST_SUCCESS,
    RESET_DEALERADDORUPDATEDSRLIST,
    LOADING_DEALERADDORUPDATEDSRLIST,
    NETWORK_ERROR_DEALERADDORUPDATEDSRLIST
} from "../types/index"


import { dealerServices } from "../../config/axios";

const resetDealerAddOrUpdateDsrList = () => {
    return { type: RESET_DEALERADDORUPDATEDSRLIST };
};

const dealerAddOrUpdateDsrList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDORUPDATEDSRLIST });
    await dealerServices
        .post("addOrUpdateDsrList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddOrUpdateDsrListsuccess(res.data));
                    // history.push({ pathname: "/index/homepage" });

                    break;
                default:
                    dispatch(dealerAddOrUpdateDsrListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDORUPDATEDSRLIST,
                payload: err
            });
        });
}
function dealerAddOrUpdateDsrListsuccess(data) {
    return {
        type: DEALERADDORUPDATEDSRLIST_SUCCESS,
        payload: data
    }
}

function dealerAddOrUpdateDsrListFailed(data) {
    return {
        type: DEALERADDORUPDATEDSRLIST_FAILED,
        payload: data
    }
}

export { resetDealerAddOrUpdateDsrList, dealerAddOrUpdateDsrList }